import { render, staticRenderFns } from "./ThankpageSetting.vue?vue&type=template&id=09f2b7cc&scoped=true&"
import script from "./ThankpageSetting.vue?vue&type=script&lang=js&"
export * from "./ThankpageSetting.vue?vue&type=script&lang=js&"
import style0 from "./ThankpageSetting.vue?vue&type=style&index=0&id=09f2b7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f2b7cc",
  null
  
)

export default component.exports